/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Skriv noget …',
  'fabric.editor.editorAssistiveLabel': 'Område for hovedindhold. Begynd at taste for at skrive tekst.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Åbn dialogboksen Hjælp',
};
